"use strict";
exports.__esModule = true;
exports.StrokeXl = exports.StrokeL = exports.StrokeM = exports.StrokeS = void 0;
exports.StrokeS = "1px";
exports.StrokeM = "2px";
exports.StrokeL = "3px";
exports.StrokeXl = "4px";
